const axios = require('axios')
const storage = require('../utils/storage');
const CONFIG = require('../core/config');

class HttpClient {
  constructor({ merchantId, apiToken, isProduction }) {
    this.baseURL = isProduction ? CONFIG.API_BASE.production : CONFIG.API_BASE.sandbox
    this.merchantId = merchantId
    this.apiToken = apiToken
    this.token = storage.getToken()
  }

  async authenticate(apiToken, merchantId) {
    try {

      if (!this.merchantId || this.merchantId === '') {
        this.merchantId = merchantId
      }
      if (!this.apiToken || this.apiToken === '') {
        this.apiToken = apiToken
      }
      if(!this.merchantId || this.merchantId === '' || !this.apiToken || this.apiToken === '') {
        throw new Error('El id del comercio y el token de la API son requeridos.')
      }

      apiToken = this.apiToken
      merchantId = this.merchantId

      const response = await axios.post(`${this.baseURL}/auth`, {
        apiToken,
        merchantId,
      })

      if (response.data.Authorization) {
        this.token = response.data.Authorization
        storage.setToken(this.token)
        return this.token
      }
    } catch (error) {
      throw new Error('Error de autenticación: ' + error.message)
    }
  }

  async request(endpoint, method = 'POST', data = {}, authToken = null) {
    const headers = {
      'Content-Type': 'application/json',
    }

    if (authToken) {
      headers.Authorization = authToken
    }

    return axios({
      url: `${this.baseURL}/${endpoint}`,
      method,
      headers,
      data,
    }).then((res) => res)
  }
}

module.exports = HttpClient;